import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';
import { AreaService } from '@common/services/AreaService/AreaService';
import { ModalService } from '@common/services/ModalService/ModalService';
import { TaskService } from '@common/services/TaskService/TaskService';
import { ClientService } from '@common/services/ClientService/ClientService';
import { SortableTableComponent } from '@common/components/SortableTableComponent/sortableTable.component';
import { AreaDetails } from '@common/models/areaDetails.model';
import { Task } from '@common/models/task.model';
import { TasksData } from '@common/models/tasksData.model';
import { ClientDetails } from '@common/models/clientDetails.model';
import { QueryParameters } from '@common/models/queryParameters.model';
import { QueryParametersUpdate } from '@common/models/queryParametersUpdate.model';
import { GetTasksOptions } from '@common/models/getTasksOptions.model';

@Component({
  templateUrl: './areaDetailsView.component.html',
  styleUrls: ['./areaDetailsView.component.scss'],
})
export class AreaDetailsViewComponent implements OnInit {
  clientKey: string;
  areaKey: string;
  breadcrumbLevels;
  bottomLevelName: string;
  areaDetails: AreaDetails = {
    areaKey: null,
    areaName: null,
    breadcrumbLevels: {
      clientKey: null,
      clientName: null,
    },
    officeKey: null,
    officeName: null,
    floorName: null,
  };
  tasksData: TasksData = {
    tasks: [],
    tasksNumber: null,
  };
  showingSubset = false;
  queryParameters: QueryParameters = {
    query: '',
    orderBy: '',
    sortOrder: 'ASC',
    page: 1,
  };
  dataFetchingTimeout;
  notFound = false;
  @ViewChild('tasksTableComponent') tasksTableComponent: SortableTableComponent;

  public fields = [
    { shortName: 'taskName', fullName: 'taskName', type: 'string', sortable: true, width: '30%' },
    { shortName: 'employees', fullName: 'employees', type: 'employees', sortable: false, width: '25%' },
    { shortName: 'repeat', fullName: 'repeat', type: 'repeat', sortable: true, width: '14%' },
    { shortName: 'taskDate', fullName: 'date', type: 'string', sortable: true, width: '12%' },
    { shortName: 'state', fullName: 'state', type: 'state', sortable: true, width: '8%' },
  ];

  constructor(
    private route: ActivatedRoute,
    public authService: AuthService,
    public areaService: AreaService,
    public modalService: ModalService,
    public taskService: TaskService,
    public clientService: ClientService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.clientKey = params['clientKey'];
      this.areaKey = params['areaKey'];
      this.getAreaDetails();
      this.getTasks();
    });

    this.route.queryParams.subscribe((queryParams) => {
      this.showingSubset = queryParams.employee || queryParams.date;
    });
  }

  getClientDetails() {
    this.clientService.getClientDetails(this.clientKey)
      .subscribe(
        (data: ClientDetails) => {
          if (data) {
            this.breadcrumbLevels = [
              { clientKey: data.clientKey, clientName: data.clientName },
            ];
          }
        },
        (err) => {},
      );
  }

  handleNotFound() {
    this.bottomLevelName = '404';
    this.notFound = true;

    this.getClientDetails();
  }

  getAreaDetails() {
    this.areaService.getAreaDetails(this.areaKey)
      .subscribe(
        (data: AreaDetails) => {
          if (data) {
            this.areaDetails = data;
            this.bottomLevelName = this.areaDetails.areaName;
            this.breadcrumbLevels = [
              {
                clientKey: data.breadcrumbLevels.clientKey,
                clientName: data.breadcrumbLevels.clientName,
              },
            ];
          }
        },
        (error) => {
          if (error.status === 404) {
            this.handleNotFound();
          } else {
            this.authService.handleRequestError(error, this.getAreaDetails.bind(this));
          }
        },
      );
  }

  getTasks() {
    const getTasksOptions: GetTasksOptions = {
      areaKey: this.areaKey,
      queryParameters: this.queryParameters,
    };

    this.taskService.getTasks(getTasksOptions)
      .subscribe(
        (data: TasksData) => {
          this.tasksData = data;

          if (this.tasksTableComponent) {
            this.tasksTableComponent.hideSpinner();
          }
        },
        error => this.authService.handleRequestError(error, this.getTasks.bind(this)),
      );
  }

  onParametersUpdated($event: QueryParametersUpdate): void {
    this.queryParameters = Object.assign(this.queryParameters, $event);
    this.getDataWithTimeout(this.getTasks.bind(this));
  }

  getDataWithTimeout(fn): void {
    clearTimeout(this.dataFetchingTimeout);
    this.dataFetchingTimeout = setTimeout(fn, 500);
  }

  deleteTask(task: Task): void {
    const proceedTaskDeletion = (allTasks?: boolean) => {
      this.modalService.closeModal();
      this.taskService.deleteTask(task.taskKey, allTasks)
        .subscribe(
          (res) => {
            this.modalService.openModal({ type: 'taskDeleted' });
            this.getTasks();
          },
          (err) => {
            this.modalService.openModal({ type: 'errorOccurred' });
          },
        );
    };

    if (task.repeat) {
      this.modalService.openModal({
        type: 'deleteRepeatingTask',
        data: task.taskDate,
        callback: proceedTaskDeletion,
      });
    } else {
      this.modalService.openModal({
        type: 'deleteSingleTask',
        callback: proceedTaskDeletion,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/areaDetailsView/areaDetailsView.ts